import Alpine from 'alpinejs';
import map from '../components/common/map';

Alpine.data('map', map);
